import { Card, CardContent } from "@/components/ui/card"
import { kpis, customersOverTime } from "../-data/fixtures"
import { ChartContainer, ChartLegend, ChartLegendContent } from "@/components/ui/chart"
import { Area, AreaChart, Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts"

export default function ReturningCustomerRate({ variant = "area" }: { variant?: "area" | "bar" }) {
  return (
    <Card className="rounded-2xl">
      <CardContent className="p-4">
        <div className="flex items-center">
          <div>
            <div className="text-xs text-muted-foreground">Returning customer rate</div>
            <div className="text-2xl font-semibold flex items-center gap-2">
              {kpis.returningCustomerRate.pct}%
              <span className="text-green-600 text-xs">↗ {kpis.returningCustomerRate.deltaPct}%</span>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <div className="text-sm text-black mb-1">Customers over time</div>
          {variant === "area" ? (
            <ChartContainer config={{ returning: { label: "Returning", color: "#2aa198" }, new: { label: "New", color: "#e16a52" } }} className="w-full h-64 aspect-auto">
              <AreaChart data={customersOverTime}>
                <CartesianGrid vertical={false} />
                <XAxis dataKey="month" tickLine={false} axisLine={false} />
                <YAxis hide />
                <Area dataKey="returning" fill="var(--color-returning)" stroke="var(--color-returning)" />
                <Area dataKey="new" fill="var(--color-new)" stroke="var(--color-new)" />
                <ChartLegend content={<ChartLegendContent />} />
              </AreaChart>
            </ChartContainer>
          ) : (
            <ChartContainer config={{ returning: { label: "Returning", color: "#2aa198" } }} className="w-full h-64 aspect-auto">
              <BarChart data={customersOverTime}>
                <CartesianGrid vertical={false} />
                <XAxis dataKey="month" tickLine={false} axisLine={false} />
                <YAxis hide />
                <Bar dataKey="returning" fill="var(--color-returning)" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ChartContainer>
          )}
        </div>
      </CardContent>
    </Card>
  )
}